import r from "./highrise661.mjs";
function o(t) {
  return t === t && !r(t);
}
export {
  o as default
};
